module.exports = __webpack_public_path__ + "static/media/06.Japan Tour.d75d1824.JPG";